<template>
    <v-app>
        <div class="app-wrapper">
            <main class="main">
<!--                <img class="logo" src="../images/sms-logo-er.png" alt="Единая Россия">-->

                <div class="modal">
                    <div class="modal__content">
                        <template v-if="!result">
                            <img class="modal__icon" src="../images/sms-press.svg">
                            <v-text-field v-mask="'(###) ###-##-##'" v-model="phone" placeholder="Введите номер телефона" class="modal__input" outlined></v-text-field>
                            <div id="captcha-container" class="smart-captcha" data-sitekey="ysc1_sI5gz2hJVsIJyFOteHZtwKtPsLcMjf4hddOYUTjy52373d6f"></div>
                            <button class="_orange" @click="handleAcceptClick">Получить смс со&nbsp;ссылкой</button>
                        </template>
                        <template v-else-if="!(result in messageMap)">
                            <img class="modal__icon" src="../images/sms-error.svg">
                            <p v-html="result"></p>
                        </template>
                        <template v-else>
                            <img class="modal__icon" :src="require(`../images/sms-${messageMap[result].icon}.svg`)">
                            <p :class="{ _clickable: messageMap[result].can_reload }" v-html="messageMap[result].text" @click="messageMap[result].can_reload ? reloadPage() : ''"></p>
                        </template>
                    </div>
                </div>
            </main>
        </div>
    </v-app>
</template>

<script>
import request from "@/axios";

const appdata = JSON.parse(document.getElementById('appdata').textContent)

export default {
    name: 'Visit',
    data: vm => ({
        phone: null,
        result: null,
        isLoading: false,
        visit_id: appdata.visit_id,
        domain: appdata.domain,
        messageMap: {
            bad_phone: { text: 'Такой телефон не&nbsp;зарегистрирован', can_reload: true, icon: 'error' },
            bad_profile: { text: 'Ошибка в профиле активиста', icon: 'error' },
            bad_entered_phone: { text: 'Неправильно указан телефон', can_reload: true, icon: 'error' },
            sms_recently_sent: { text: 'Сообщение со&nbsp;ссылкой не&nbsp;может быть отправлено чаще, чем раз в&nbsp;5&nbsp;минут', can_reload: true, icon: 'error' },
            success: { text: 'Вам было отправлено сообщение со&nbsp;ссылкой для контроля&nbsp;явки', icon: 'ok' },
            bad_captcha: { text: 'Подтвердите, что вы не&nbsp;робот', can_reload: true, icon: 'press' },
        }
    }),
    computed: {},
    methods: {
        async handleAcceptClick() {
            if (this.isLoading) return;
            this.result = null;
            if (!this.phone) {
                this.result = 'bad_entered_phone';
                return;
            }
            const phone = this.phone.replace(/\D/g, '');
            if (phone.length != 10) {
                this.result = 'bad_entered_phone';
                return;
            }
            const payload = {
                phone: this.phone,
                token: document.querySelector('[name=smart-token]').value,
            };
            this.isLoading = true;

            try {
                const response = await request.post(
                    this.domain + "/" + this.visit_id,
                    payload
                );

                this.result = response.data.result;
            }
            catch (err) {
                this.result = err.message;
            }
            finally {
                this.isLoading = false;
            }

        },

        reloadPage() {
            document.location.reload();
        },
    },
    mounted() {
        let yaCaptchaScript = document.createElement('script');
        yaCaptchaScript.setAttribute('src', 'https://smartcaptcha.yandexcloud.net/captcha.js');
        yaCaptchaScript.setAttribute('defer', true);
        document.head.appendChild(yaCaptchaScript);
    },
}
</script>

<style>
*,
::before,
::after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html {
    height: 100%;
    overflow: auto;
}

body {
    height: 100%;
    min-width: 320px;
    font-family: 'Nunito Sans', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    padding: 0;
}


#app {
    height: 100%;
    font-family: 'Nunito Sans', sans-serif !important;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    margin: 0;
    padding: 0;
    background-color: #B8CDE8 !important;
}

.app-wrapper {
    position: relative;
    height: 100%;
}

img {
    max-width: 100%;
    vertical-align: bottom;
}

a {
    text-decoration: none;
    color: #2C2C2E !important;
}

ul {
    list-style: none;
}

.main {
    position: relative;
    background-image: url("https://go-cdn.er.ru/static/a1c35ff3650beca3c72e713893b40932.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    min-height: 100vh;
    padding: 1px;
}

.logo {
    position: absolute;
    top: 60px;
    left: 60px;
}

.modal {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.modal__content {
    max-width: 442px;
    min-height: 394px;
    border-radius: 16px;
    margin: auto;
    margin-left: 24px;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 30px;
    text-align: center;
    color: #2C2C2E;
    gap: 24px;
    background: rgba(255, 255, 255, 0.30);
    backdrop-filter: blur(8px);
}

.modal__icon {
    width: 86px;
    height: 86px;
}

.modal__input {
    width: 100%;
}

.modal__input input {
    background-color: transparent;
    padding: 10px 15px;
    border-radius: 4px;
    border: 2px solid #000000;
    font-size: 20px;
    text-align: center;
}

.modal__input input::placeholder {
    color: #2F80ED !important;
    opacity: 1;
}

.modal__input.v-input--is-focused input::placeholder {
    opacity: 0 !important;
}

.modal__input .v-input__slot {
    min-height: 40px !important;
    background-color: transparent !important;
    padding: 0 !important;
    border: none !important;
}

button {
    color: #2C2C2E;
    border: none;
    border: 2px solid #2C2C2E;
    border-radius: 4px;
    opacity: 0.8;
    font-size: 22px;
    font-weight: 700;
    background-color: transparent;
    padding: 5px 15px;
    cursor: pointer;
    margin-top: auto;
}

button._orange {
    padding: 7px 15px;
    background-color: #ED1C24;
    color: #FFFFFF;
    border: none;
}

h2 {
    font-size: 32px;
}

p {
    font-size: 20px;
}

p._clickable {
    cursor: pointer;
    text-decoration: underline;
    font-weight: bold;
}

p._clickable:hover {
    color: #ED1C24;
}

.smart-captcha {
    width: 100%;
    height: 102px;
    margin-top: -6px;
    margin-bottom: 24px;
}


@media screen and (max-width: 480px) {
    .logo {
        left: 50%;
        transform: translateX(-50%);
    }

    .modal__content {
        min-height: 320px;
        padding: 25px 16px;
        gap: 16px;
    }

    .modal__icon {
        width: 62px;
        height: 62px;
    }

    .modal__input {
        font-size: 14px;
    }

    button {
        font-size: 16px;
    }

    h2 {
        font-size: 18px;
    }

    p {
        font-size: 14px;
    }
}
</style>